import { KioskBrowserModals } from './kiosk_browser_modals.js';

const parseLabelDetails = (detailsLine = '') => {
  return detailsLine
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .reduce((acc, line) => {
      const match = line.match(/^(Refeitório|Periodo|Período|Data):\s*(.+)$/i);
      if (!match) return acc;

      const [, label, value] = match;
      const normalized = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

      if (normalized === 'refeitorio') acc.dining_hall = value.trim();
      if (normalized === 'periodo') acc.meal_period = value.trim();
      if (normalized === 'data') acc.meal_date = value.trim();

      return acc;
    }, {});
};

const parseWalkInSuccessPayload = (data = {}) => {
  const text = data.text || '';
  const message = text.split('\n\n')[0] || text;
  const detailsLine = text.split('\n\n')[1] || '';
  const details = parseLabelDetails(detailsLine);

  return {
    title: data.title,
    message,
    dining_hall: details.dining_hall || '',
    meal_period: details.meal_period || '',
    meal_date: details.meal_date || ''
  };
};

const isWalkInSuccess = (text = '') =>
  text.includes('Consumo sem reserva registado') ||
  text.includes('walk-in') ||
  text.includes('Refeitório:');

export const SessionTimeout = {
  mounted() {}
};

export const ValidationErrors = {
  mounted() {
    this._activeAuthAttempt = null;
    this._lastEmojiAlertSignature = null;

    this.handleEvent("show_validation_errors", (data) => {
      this.showModernAlert(data.title, data.text, data.icon || 'error');
    });

    this.handleEvent("show_success_alert", (data) => {
      if (isWalkInSuccess(data.text || '')) {
        this.showWalkInSuccessModal(parseWalkInSuccessPayload(data));
      } else {
        this.showModernAlert(data.title, data.text, data.icon || 'success');
      }
    });

    this.handleEvent("show_checkin_success", (data) => {
      this.closeCheckinConfirmationModal({ sync: false });
      this.showCheckinSuccessModal(data);
    });

    this.handleEvent("close_success_modals", () => {
      this.closeKioskSuccessModals();
    });

    this.handleEvent("show_already_checked_in_modal", (data) => {
      this.showAlreadyCheckedInModal(data);
    });

    this.handleEvent("show_already_served_modal", (data) => {
      this.showAlreadyServedModal(data);
    });

    this.handleEvent("show_alert", (data) => {
      this.showEmojiAlert(data);
    });

    this.handleEvent("show_operation_alert", (data) => {
      this.closeCheckinConfirmationModal({ sync: false });
      this.showOperationAlert(data);
    });

    this.handleEvent("close_kiosk_modals", () => {
      this.closeCheckinFlowBrowserModals();
    });

    this.handleEvent("show_walk_in_confirm", (data) => {
      this.showWalkInConfirmModal(data);
    });

    this.handleEvent("show_walk_in_conflict", (data) => {
      this.showWalkInConflictModal(data);
    });

    this.handleEvent("show_checkin_confirm", (data) => {
      this.showCheckinConfirmModal(data);
    });

    this.handleEvent("show_cancellation_success", (data) => {
      this.showCancellationSuccessModal(data);
    });

    this.handleEvent("confirm_action", (data) => {
      this.showConfirmAlert(data);
    });

    this.handleEvent("auth_attempt_started", (payload) => {
      this._lastEmojiAlertSignature = null;
      this._activeAuthAttempt = payload?.attempt_ref ?? null;
    });

    this.handleEvent("auth_success", () => {
      this._lastEmojiAlertSignature = null;
      this._activeAuthAttempt = null;
      this.syncKioskInterfaceControls();
    });

    this.handleEvent("auth_input_reset", () => {
      this._lastEmojiAlertSignature = null;
      this._activeAuthAttempt = null;
      this.syncKioskInterfaceControls();
    });

    this.handleEvent("option_action", (data) => {
      this.showOptionAction(data);
    });

    this.handleEvent("navigate_to", ({ url }) => {
      try {
        window.location.assign(url);
      } catch (_) {
        window.location.href = url;
      }
    });

    this.syncKioskInterfaceControls();
  },

  kioskModalOverlayIds() {
    return KioskBrowserModals.kioskModalOverlayIds();
  },

  closeKnownKioskModals(ids = this.kioskModalOverlayIds()) {
    return KioskBrowserModals.closeKnownKioskModals(this, ids);
  },

  closeCheckinConfirmationModal(options = {}) {
    return KioskBrowserModals.closeCheckinConfirmationModal(this, options);
  },

  closeKioskSuccessModals(options = {}) {
    return KioskBrowserModals.closeKioskSuccessModals(this, options);
  },

  closeCheckinFlowBrowserModals(options = {}) {
    return KioskBrowserModals.closeCheckinFlowBrowserModals(this, options);
  },

  hideKioskInterfaceControls() {
    return KioskBrowserModals.hideKioskInterfaceControls(this);
  },

  showKioskInterfaceControls() {
    return KioskBrowserModals.showKioskInterfaceControls(this);
  },

  syncKioskInterfaceControls() {
    return KioskBrowserModals.syncKioskInterfaceControls(this);
  },

  showModernAlert(title, text, icon) {
    return KioskBrowserModals.showModernAlert(this, title, text, icon);
  },

  showEmojiAlert(data) {
    return KioskBrowserModals.showEmojiAlert(this, data);
  },

  showOperationAlert(data) {
    return KioskBrowserModals.showOperationAlert(this, data);
  },

  showWalkInConfirmModal(data) {
    return KioskBrowserModals.showWalkInConfirmModal(this, data);
  },

  showWalkInConflictModal(data) {
    return KioskBrowserModals.showWalkInConflictModal(this, data);
  },

  showWalkInSuccessModal(data) {
    return KioskBrowserModals.showWalkInSuccessModal(this, data);
  },

  showCheckinSuccessModal(data) {
    return KioskBrowserModals.showCheckinSuccessModal(this, data);
  },

  showAlreadyCheckedInModal(data) {
    return KioskBrowserModals.showAlreadyCheckedInModal(this, data);
  },

  showAlreadyServedModal(data) {
    return KioskBrowserModals.showAlreadyServedModal(this, data);
  },

  showCheckinConfirmModal(data) {
    return KioskBrowserModals.showCheckinConfirmModal(this, data);
  },

  showCancellationSuccessModal(data) {
    return KioskBrowserModals.showCancellationSuccessModal(this, data);
  },

  showOptionAction(data) {
    return KioskBrowserModals.showOptionAction(this, data);
  },

  showConfirmAlert(data) {
    return KioskBrowserModals.showConfirmAlert(this, data);
  }
};

export const KioskValidationHooks = {
  SessionTimeout,
  ValidationErrors
};
